import axiosInstance from "./axiosInstance";

const BASE = "/cron-email-templates";

/**
 * Fetch templates for a cron
 */
export const fetchCronTemplates = (cronType) => {
  return axiosInstance.get(`${BASE}/`, {
    params: { cron_type: cronType }
  });
};

/**
 * Update template
 */
export const updateCronTemplate = (id, data) => {
  return axiosInstance.patch(`${BASE}/${id}/`, data);
};

export const createCronTemplate = (data) => {
  return axiosInstance.post("/cron-email-templates/", data);
};


export const previewCronTemplate = (cronType, weekNumber) => {
  return axiosInstance.get("/cron-template-preview/", {
    params: {
      cron_type: cronType,
      week_number: weekNumber
    }
  });
};